var render, staticRenderFns
import script from "./KInput.vue?vue&type=script&lang=js"
export * from "./KInput.vue?vue&type=script&lang=js"
import style0 from "./KInput.vue?vue&type=style&index=0&id=d4c6aece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c6aece",
  null
  
)

export default component.exports